import { render, staticRenderFns } from "./MarketDrawer.vue?vue&type=template&id=2db80e2f&scoped=true"
import script from "./MarketDrawer.vue?vue&type=script&lang=ts"
export * from "./MarketDrawer.vue?vue&type=script&lang=ts"
import style0 from "./MarketDrawer.vue?vue&type=style&index=0&id=2db80e2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db80e2f",
  null
  
)

export default component.exports